<template>
<div>
    <Partners v-if="route == '/employer-advisor/partners'"></Partners>
    <AddPartner v-if="route == '/employer-advisor/partners/add-new'"></AddPartner>
    <Result v-if="route == '/employer-advisor/partners/add-new/result'"></Result>
    <InvitePartner v-if="route == '/employer-advisor/partners/invite-partner'"></InvitePartner>
    <Partner v-if="route == '/employer-advisor/partners/partner'"></Partner>

</div>

</template>
<script>
import Partners from './PartnersTable.vue'
import AddPartner from './AddPartner.vue'
import InvitePartner from './InvitePartner.vue'
import Partner from './Partner.vue'
import Result from './Result.vue'

export default{
    components:{
        Partners,
        AddPartner,
        InvitePartner,
        Partner,
        Result
    },
    computed:{
        route(){
            return this.$route.path
        }
    },
    created(){
        if(this.route.includes('/employer-advisor/partners/add-new/result') || this.route.includes('/employer-advisor/partners/partner')){
            this.$router.replace('/employer-advisor/partners/add-new')
        }
    }
}
</script>